export const generateRandom = () => {
    const array = new Uint32Array(1);
    window?.crypto?.getRandomValues(array);
    const randomValue2 = array[0] / 2 ** 32;
    return randomValue2;
  };